"use strict";

import "./Form.css";
import React from "react";
import classnames from "classnames";

export default class Form extends React.Component {
	
	render() {
		return (
			<div {...this.props} className={classnames(this.props.className, "Form")}>
				{this.props.children}
			</div>
		);
	}
	
}


// WEBPACK FOOTER //
// ./~/vwa/components/Form/Form.jsx